import Modal from "react-modal";
import {
  AgreeAnnotationContainer,
  AgreeCheckBoxContainer,
  AgreeContainer,
  BottomSection,
  BtnContainer,
  CancelBtnContainer,
  Container,
  ContentContainer,
  DomainListContainer,
  TermContainer,
  TitleContainer,
  TopSection,
} from "./GoogleWorkspaceMemberIntegrationModal.styles";
import UI from "@mile-meeting/mile-ui";
import Callout from "uis/Callout";
import DomainField from "./DomainField";
import { useEffect, useState } from "react";

export type GoogleWorkspaceMemberIntegrationModalProps = {
  modalIsOpen: boolean;
  closeModal: () => void;
  domainList?: string[];
  onHandleSync?: () => void;
  onHandleReSync?: () => void;
  onHandleOrgUnitSync?: () => void;
  isReSync?: boolean;
};

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    width: "600px",
    borderRadius: "20px",
    transform: "translate(-50%, -50%)",
    padding: 0,
    margin: 0,
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};

export default function GoogleWorkspaceMemberIntegrationModal(props: GoogleWorkspaceMemberIntegrationModalProps) {
  const {
    modalIsOpen,
    isReSync,
    domainList = [],
    onHandleSync,
    onHandleReSync,
    closeModal,
    onHandleOrgUnitSync,
  } = props;
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (modalIsOpen) {
      setChecked(false);
    }
  }, [modalIsOpen]);

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelBtnContainer>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelBtnContainer>
        <TitleContainer>
          <UI.Icon name="google" size={24} />
          <UI.Typography type="heading02" fontStyle="bold" color="var(--alias-color-label-neutral)">
            Google Workspace 멤버 정보 연동
          </UI.Typography>
        </TitleContainer>
        <ContentContainer>
          <TopSection>
            <Callout
              context={`GWS에서 확인된 도메인 목록입니다.\n연동을 계속하시면 해당 도메인에 속한 계정만 연동 및 동기화가 진행됩니다.\n연동이 완료되면 GWS 멤버 정보 변동 발생 시, 감지하여 안내해 드립니다.`}
            />
            <DomainListContainer>
              {domainList.map((domain) => (
                <DomainField domain={domain} key={domain} />
              ))}
            </DomainListContainer>
          </TopSection>
          <BottomSection>
            <AgreeContainer>
              <AgreeCheckBoxContainer>
                <TermContainer onClick={() => setChecked(!checked)}>
                  <UI.CheckBox selected={checked} />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                      이용약관 동의
                    </UI.Typography>
                    <UI.Typography type="body02 normal" fontStyle="medium" color="var(--alias-color-primary-normal)">
                      <span>(</span>필수<span>)</span>
                    </UI.Typography>
                  </div>
                </TermContainer>
                <UI.ButtonGroups.Text
                  onClick={() => {
                    window.open("https://policy.mile.im/service-agree/2025.03.28.html");
                  }}
                  title="전체 보기"
                  size="small"
                  type="secondary"
                  styles={{
                    text: {
                      textDecoration: "underline",
                    },
                  }}
                />
              </AgreeCheckBoxContainer>
              <AgreeAnnotationContainer>
                <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-alternative)">
                  멤버 동기화 시, GWS 멤버들이 별도의 절차없이 Mile 회원으로 가입됩니다.
                </UI.Typography>
              </AgreeAnnotationContainer>
            </AgreeContainer>
            <BtnContainer>
              <UI.Button
                disabled={!checked || loading}
                title={isReSync ? "재연동하기" : "연동하기"}
                onClick={async () => {
                  if (!checked || loading) return;
                  setLoading(true);
                  if (isReSync) await onHandleReSync?.();
                  else await onHandleSync?.();
                  setLoading(false);
                }}
                size="large"
                style={{
                  width: "100%",
                }}
              />
              <div style={{ padding: "8px 0" }}>
                <UI.ButtonGroups.Text title="조직 단위로 연동하기" type="secondary" onClick={onHandleOrgUnitSync} />
              </div>
            </BtnContainer>
          </BottomSection>
        </ContentContainer>
      </Container>
    </Modal>
  );
}
